import { mapActions, mapState } from 'vuex'
import constants from '@/util/constants'
import Endereco from '@/components/layout/endereco/Endereco.vue'
import util from '@/util'

export default {
  name: 'aba-endereco',
  components: {
    Endereco
  },
  props: {
    endereco: {
      type: Object,
      required: true
    }
  },
  model: {
    prop: 'endereco',
    event: 'update'
  },
  computed: {
    ...mapState('escritorios', ['dadosRetorno', 'flagsDeControle', 'listaUnidadesFederativas']),
    formulario: {
      get () {
        return this.endereco
      },
      set (endereco) {
        this.$emit('input', endereco)
      }
    }
  },

  data: () => {
    return {
    }
  },
  mounted () {
    this.preencherFormulario(this.endereco)
  },

  methods: {
    ...mapActions('escritorios', ['ActionDefinirListaUnidadesFederativas']),
    async obterUnidadesFederativas (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }
      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'nome': valorDigitadoParaBusca }
      }
      await this.ActionDefinirListaUnidadesFederativas(parametrosRequisicao)
      callbackFlagCarregamento = false
      return this.listaUnidadesFederativas
    },
    preencherFormulario (dadosEmpresa) {
      const { cep, endereco, numero, complemento, bairro, cidade, uf, pais } = dadosEmpresa
      const formulario = {
        ...this.formulario,
        endereco: {
          cep,
          endereco,
          numero,
          complemento,
          bairro,
          cidade,
          uf: { code: uf, label: uf },
          pais
        }
      }
      this.formulario = formulario
    }
  }
}
